var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23008 21.4548V18.3505C1.65223 18.0167 0.443674 16.6148 0.477245 14.9458V4.4312C0.477245 2.52856 2.02152 0.959717 3.96864 0.959717H21.4256C23.3392 0.959717 24.917 2.49518 24.917 4.4312V14.9792C24.917 16.8818 23.3727 18.4507 21.4256 18.4507H9.44073L5.47934 22.3895C5.21077 22.6565 4.87506 22.79 4.53935 22.79C4.20364 22.79 3.86793 22.6565 3.63293 22.4229C3.39793 22.1558 3.23008 21.822 3.23008 21.4548Z",
    fill: "#0079FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9273 5.3584L12.559 6.72671L14.5493 8.71699H7.50415V10.6394H14.5493L12.559 12.6297L13.9273 13.998L18.2471 9.6782L13.9273 5.3584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentText);
export default __webpack_public_path__ + "static/media/sentText.166a04426ab99904e6451dc0f7addf95.svg";
export { ForwardRef as ReactComponent };